import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridActionButton } from '../GridActionButton/GridActionButton';
import { IGridActionProps } from '../GridAction.interface';

export const GridActionDelete: FunctionComponent<IGridActionProps> = (props) => {
  const { disabled, label, onClick } = props;

  const { t } = useTranslation();

  return (
    <GridActionButton
      disabled={disabled}
      icon={<DeleteIcon />}
      label={label ?? t('text:common.button.delete')}
      onClick={onClick}
    />
  );
};
